module.exports = __webpack_public_path__ + "static/media/ScreenShot_ShowingDropdn_2020-06-24.01efe49a.png";